import { render, staticRenderFns } from "./ApprovedDesigns.vue?vue&type=template&id=4be8540a"
import script from "./ApprovedDesigns.vue?vue&type=script&lang=js"
export * from "./ApprovedDesigns.vue?vue&type=script&lang=js"
import style0 from "./ApprovedDesigns.vue?vue&type=style&index=0&id=4be8540a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports